function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 3.17,
  height: 7.72,
  x: 5.78,
  y: 9.97,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.78 9.97v7.72h3.17V9.98H5.78z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  width: 6.78,
  height: 4.59,
  x: 9.2,
  y: 14.41,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.2 19H16v-4.59H9.2V19z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v26H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.84 13.85a3.27 3.27 0 10-5.9 2.58l3.23-1.41 1.35-.6v.01zm-5.04.94l-.01-.17a1.87 1.87 0 013.27-1.23zm4.14 2.17a3.24 3.24 0 01-4.08.4l.77-1.18a1.9 1.9 0 002.34-.22zm1.33-.81V9.97h1.17v6.01a.12.12 0 00.08.14l1.02.4-.46 1.2-1.2-.51c-.45-.2-.6-.47-.6-1.06"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#289ad3",
  d: "M8.95 11.58a3.01 3.01 0 000 4.55L7.5 17.69a5.15 5.15 0 01.05-7.72s1.39 1.62 1.4 1.6z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ec442d",
  d: "M15.98 14.82A5.15 5.15 0 019.2 18.7l.69-2.01a3.02 3.02 0 004-2.28z"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fdda2e",
  d: "M15.97 12.82l-2.08.48a3.02 3.02 0 00-4-2.28L9.2 9.01a5.15 5.15 0 016.77 3.8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29.52 13.15a1.85 1.85 0 000 2.8l-.89.96a3.17 3.17 0 01.03-4.75l.86.98zm4.33 1.99a3.17 3.17 0 01-4.17 2.39l.42-1.24a1.86 1.86 0 002.47-1.4zm-.01-1.24l-1.28.3a1.86 1.86 0 00-2.46-1.4l-.42-1.24a3.17 3.17 0 014.16 2.35"
});

function SvgElo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = React.forwardRef(SvgElo);
export default __webpack_public_path__ + "static/media/elo.5fb48522.svg";
export { ForwardRef as ReactComponent };